import React from "react";
import {IonRouterOutlet} from "@ionic/react";
import {Route} from "react-router-dom";
import {isAuthenticated} from "../lib/utils/auth.utils";

import Private from "./private.routes";
import Public from "./public.routes";

import MainLayout from "../layouts";

import Dashboard from "../pages/Dashboard";

import Login from "../pages/Auth/Login";
import Register from "../pages/Auth/Register";
import ForgetPassword from "../pages/Auth/ForgetPassword";
import ResetPassword from "../pages/Auth/ResetPassword";
import CompleteRegistration from "../pages/Auth/CompleteRegistration";
import SetPassword from "../pages/Auth/SetPassword";

import Quote from "../pages/Quote";
import QuoteDetails from "../pages/Quote/Details";

import Services from "../pages/Services";
import Services_Auto from "../pages/Services/Auto";
import Services_Administrative from "../pages/Services/Administrative";
import Services_Details from "../pages/Services/Details";

import PersonalInvoices from "../pages/Invoices";
import PersonalArea from "../pages/Personale/Area";
import PersonalAttesa from "../pages/Personale/Attesa";
import PersonalServizi from "../pages/Personale/Servizi";
import PersonalServiziEdit from "../pages/Personale/Servizi/Edit";
import PersonalProfile from "../pages/Personale/Profile";
import PersonalCarrello from "../pages/Personale/Carrello";

import PersonalPreventivi from "../pages/Personale/Preventivi";
import PersonalPreventiviDetails from "../pages/Personale/Preventivi/Details";

import LincenseRenewalSpecialPricing from "../pages/Quote/special/license-renewal";
import OwnershipTransferSpecialPricing from "../pages/Quote/special/ownership-transfer";
import VehicleRegistrationSpecialPricing from "../pages/Quote/special/vehicle-registration";

import PrivacyPolicyOrder from "../pages/PrivacyPolicy/Order";
import PrivacyPolicyQuote from "../pages/PrivacyPolicy/Quote";
import PrivacyPolicyRegistration from "../pages/PrivacyPolicy/Registration";

import Download from "../pages/Download";
import AcceptEstimate from "../pages/Auth/AcceptEstimate";
import CommonRoute from "./common.routes";
import AddToCart from "../pages/Personale/AddToCart";

const Routes = () => {
  return (
    <IonRouterOutlet>
      <Route
        path="/download"
        exact={true}
        render={() => (
          <MainLayout>
            <Download />
          </MainLayout>
        )}
      />

      <Route
        path="/privacy-policy/order"
        exact={true}
        render={() => (
          <MainLayout>
            <PrivacyPolicyOrder />
          </MainLayout>
        )}
      />

      <Route
        path="/privacy-policy/quote"
        exact={true}
        render={() => (
          <MainLayout>
            <PrivacyPolicyQuote />
          </MainLayout>
        )}
      />

      <Route
        path="/privacy-policy/registration"
        exact={true}
        render={() => (
          <MainLayout>
            <PrivacyPolicyRegistration />
          </MainLayout>
        )}
      />

      <Public
        path="/login"
        exact={true}
        component={Login}
        layout={MainLayout}
      />

      <Public
        path="/register"
        exact={true}
        component={Register}
        layout={MainLayout}
      />

      <Public
        path="/forgot-password"
        exact={true}
        component={ForgetPassword}
        layout={MainLayout}
      />

      <Public
        path="/reset-password"
        exact={true}
        component={ResetPassword}
        layout={MainLayout}
      />

      <Public
        path="/registration/verify"
        exact={true}
        component={SetPassword}
        layout={MainLayout}
      />

      <Public
        path="/registration/complete"
        exact={true}
        component={CompleteRegistration}
        layout={MainLayout}
      />

      <Public
        path="/estimate/accept/:token"
        exact={true}
        component={AcceptEstimate}
        layout={MainLayout}
      />

      <CommonRoute
        path="/servizi"
        exact={true}
        component={Services}
        layout={MainLayout}
      />
      <CommonRoute
        path="/servizi/auto"
        exact={true}
        component={Services_Auto}
        layout={MainLayout}
      />

      <CommonRoute
        path="/servizi/amministrative"
        exact={true}
        component={Services_Administrative}
        layout={MainLayout}
      />

      <Private
        path="/servizi/details/:id"
        exact={true}
        component={Services_Details}
        layout={MainLayout}
      />

      <CommonRoute
        path="/preventivo"
        exact={true}
        component={Quote}
        layout={MainLayout}
      />

      <CommonRoute
        path="/preventivo/details/:id"
        exact={true}
        component={QuoteDetails}
        layout={MainLayout}
      />

      <Private
        path="/preventivo/special/license-renewal"
        exact={true}
        component={LincenseRenewalSpecialPricing}
        layout={MainLayout}
      />

      <Private
        path="/preventivo/special/ownership-transfer"
        exact={true}
        component={OwnershipTransferSpecialPricing}
        layout={MainLayout}
      />

      <Private
        path="/preventivo/special/vehicle-registration"
        exact={true}
        component={VehicleRegistrationSpecialPricing}
        layout={MainLayout}
      />

      <CommonRoute
        path="/"
        exact={true}
        component={Dashboard}
        layout={MainLayout}
      />

      <Private
        path="/personale"
        exact={true}
        component={PersonalArea}
        layout={MainLayout}
      />

      <Private
        path="/personale/servizi"
        exact={true}
        component={PersonalServizi}
        layout={MainLayout}
      />

      <Private
        path="/personale/servizi/:id"
        exact={true}
        component={PersonalServiziEdit}
        layout={MainLayout}
      />

      <Private
        path="/personale/preventivi"
        exact={true}
        component={PersonalPreventivi}
        layout={MainLayout}
      />

      <Private
        path="/personale/preventivi/:id"
        exact={true}
        component={PersonalPreventiviDetails}
        layout={MainLayout}
      />

      <Private
        path="/personale/dati"
        exact={true}
        component={PersonalProfile}
        layout={MainLayout}
      />

      <Private
        path="/personale/invoices"
        exact={true}
        component={PersonalInvoices}
        layout={MainLayout}
      />

      <Private
        path="/personale/attesa"
        exact={true}
        component={(routerProps) => (
          <PersonalAttesa {...routerProps} handleGoToNextPage={undefined} />
        )}
        layout={MainLayout}
      />

      <Private
        path="/personale/carrello"
        exact={true}
        component={(routerProps) => (
          <PersonalCarrello {...routerProps} formFields={undefined} />
        )}
        layout={MainLayout}
      />

      <Private
        path="/personale/add-to-cart"
        exact={true}
        component={AddToCart}
        layout={MainLayout}
      />
    </IonRouterOutlet>
  );
};

export default Routes;
